// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 指标条件组列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /indicator/condition-group/list */
export async function indicatorConditionGroupListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListIndicatorConditionGroupDetailResp>(
    '/indicator/condition-group/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
